// extracted by mini-css-extract-plugin
export default {"disabled":"Button_disabled__DkgJ+"};